import * as React from 'react';

const SvgFlagOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M6.5 5.656a.75.75 0 0 0-1.5 0V18.85a.75.75 0 0 0 1.5 0v-3.813l1.462-.365a5.85 5.85 0 0 1 4.033.443l.336-.671-.336.67.08.04a7.35 7.35 0 0 0 4.968.58l2.282-.537a.75.75 0 0 0 .574-.811 35 35 0 0 1-.003-7.533.75.75 0 0 0-.918-.811l-2.279.536a5.85 5.85 0 0 1-3.954-.462l-.079-.04A7.35 7.35 0 0 0 7.6 5.52L6.5 5.795zm0 1.685v6.15l1.099-.274a7.35 7.35 0 0 1 5.067.556l.08.04a5.85 5.85 0 0 0 3.953.461l1.643-.386a36.4 36.4 0 0 1-.036-6.147l-1.264.297a7.35 7.35 0 0 1-4.968-.58l-.079-.04a5.85 5.85 0 0 0-4.033-.442z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgFlagOutlined;
